export default __webpack_public_path__ + "static/media/csa-logo24.b5433a96.gif";